<script>
    import axios from "axios";

    import Header from "../Headers/Header.svelte";
    import Button from "../Buttons/Button.svelte";
    import Input from "../Inputs/Input.svelte";

    import { successToast, errorToast500 } from "../../utils/CommonToasts";

    let isSubmitting = false;
    let email;

    const submitHandler = async () => {
        isSubmitting = true;
        await axios
            .post(
                APIBACKEND + "/user/checkemail",
                { email: email },
                { withCredentials: true }
            )
            .then(function (res) {
                if (res.data.exists) {
                    setTimeout(function () {
                        successToast(
                            "A login link has been sent to your email!"
                        );
                        isSubmitting = false;
                    }, 800);
                } else {
                    window.location.replace("/account");
                }
            })
            .catch(() => {
                errorToast500();
            });
    };
</script>

<style type="text/scss">
    @import "../../styles/_mixins.scss";

    .hero {
        display: flex;
        align-items: center;
        margin-bottom: var(--spacer-large);
        flex-wrap: wrap;

        @include sm {
            flex-wrap: nowrap;
            padding: var(--spacer-small);
        }

        .email-input {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: var(--spacer-medium);
            padding: 0 var(--spacer-large);

            @include sm {
                justify-content: flex-start;
                padding: 0;
            }

            :global(input) {
                width: 80%;
            }

            :global(button) {
                margin-top: var(--spacer-small);
                margin-left: var(--spacer-tiny);

                @include sm {
                    margin-top: 0;
                    margin-left: var(--spacer-small);
                }
            }
        }

        img {
            width: 100%;

            @include sm {
                margin-left: var(--spacer-medium);
                width: 50%;
            }
        }
    }
</style>

<div class="hero">
    <div>
        <Header
            title="Find your next <p style='color: var(--color-orange); display: inline;'>co-founder</p>"
            subtitle="We're the shortest bridge that connects you to ideas and people."
            massive
            position="left" />

        <form class="email-input" on:submit|preventDefault={submitHandler}>
            <Input
                name="email"
                placeholder="email@email.com"
                type="email"
                bind:value={email}
                required />

            <Button
                text="Get Started"
                buttonType="submit"
                primary
                disabled={isSubmitting} />
        </form>
    </div>
    <img
        alt="two people sitting on a couch talking"
        src="https://assets.umso.co/7/3_music_general.svg" />
</div>
